import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmMappingsQueryDtoSchema } from '../schema/AlgorithmMappingsQueryDtoSchema';
import { AlgorithmMappingsQueryDtoType } from '../schema/types';

interface AlgorithmMappingsQueryParams {
  id: number;
}

const getAlgorithmMappings = (params?: AlgorithmMappingsQueryParams) =>
  apiClient
    .get<AlgorithmMappingsQueryDtoType>(expand(AlgorithmUrl.MAPPINGS, params))
    .then((response) => AlgorithmMappingsQueryDtoSchema.parse(response.data));

export const useGetAlgorithmMappingsQuery = createApiQueryHook(
  ['algorithm-mappings'],
  getAlgorithmMappings,
);
